module.exports = __webpack_public_path__ + "static/media/820.5f9d6b07.png";